export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";